import React from "react";
import { Modal } from "antd";
import Moment from "react-moment";
import Draggable from "react-draggable";
import { Table } from "react-bootstrap";
const ViewLibrary = ({
  show,
  setShow,
  onStart,
  draggleRef,
  bounds,
  onMouseOver,
  onMouseOut,
  disabled,
  title,
  sessionLibraryData
}) => {

  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css">
          <Table>
            <thead className="headerFixed">
              <tr>
                <th>Attribute</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Folder Name</td>
                <td>{sessionLibraryData?.name}</td>
              </tr>
              <tr>
                <td>Description</td>
                <td>{sessionLibraryData?.description}</td>
              </tr>
              <tr>
                <td>Path</td>
                <td>{sessionLibraryData?.Path}</td>
              </tr>
              <tr>
                <td>Created Date | Time</td>
                <td><Moment format="DD MMM YYYY | HH:mm" withTitle>
                  {sessionLibraryData?.createdAt}
                </Moment></td>
              </tr>
              <tr>
                <td>Updated Date | Time</td>
                <td><Moment format="DD MMM YYYY | HH:mm" withTitle>
                  {sessionLibraryData?.updatedAt}
                </Moment></td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Modal>
    </>
  );
};
export default ViewLibrary;
